import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import localizationResources from './i18nResources'

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    supportedLngs: localizationResources.supportedLanguages,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      // format: (value, format, lng) => { // legacy usage
      //   if (value instanceof Date) {
      //     return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(DateTime[format])
      //   }
      //   return value;
      // }
    },
    resources: localizationResources.resources,
  })

// update HTML document language now and whenever i18n language is changed
const updateDocumentLang = (lng: string) =>
  document.documentElement.setAttribute('lang', lng)
updateDocumentLang(i18n.language)
i18n.on('languageChanged', updateDocumentLang)

export default i18n
